module.exports = __webpack_public_path__ + "static/img/mixed_lesson_teach.3713c28c.png";